import type { CTATypes, HomeProductStatus } from 'src/consts';

import type { Patient } from './patient';

export interface HomePrescriptionLifecycle {
  currentPhase: number;
  maxPhaseCount: number;
  barState: string;
  phaseDate: string;
}

export interface HomePrescriptionRefillStatus {
  status: string;
  hyperlink?: {
    startIndex: number;
    endIndex: number;
    prePopulatedText: string;
  };
  showNewBadge: boolean;
}

export interface CTA {
  action: {
    type: CTATypes;
    metadata: {
      phone?: string;
      prePopulatedText?: string;
      orderUUID?: string;
      chat_type?: string;
    } | null;
  };
}

export enum HomeItemType {
  transfer = 'transfer',
  prescription = 'prescription',
}

export const PrescriptionStatuses = {
  refillRequestReceived: "Thank you for your refill request. We'll update you in 3 business days.",
  processRefillRequestReceived: "We're working on your prescription. We'll contact you as soon as it's ready.",
};

export const PrescriptionStatusTypes = {
  refillRequestReceived: 'Refill Request Received',
};

export interface HomePrescriptionItem extends Patient {
  id: string;
  cta?: CTA;
  name: string;
  genericName?: string;
  status: HomeProductStatus;
  statusText?: string;
  instructions?: string;
  type: HomeItemType;
  source?: 'doctor' | 'pharmacy';
  dosage: string;
  quantity: string;
  nextRefillDate: string;
  ndc?: string;
  refillsRemaining: number;
  refillStatusText: string;
  refillStatus: HomePrescriptionRefillStatus;
  inBagRefillStatusText?: string;
  prescriptionFulfillmentId?: string;
  priceInDollars: number;
  patientMedicationId: number;
  medicationId: string;
  expirationDate?: string;
  showPrice: boolean;
  patientName?: string;
  showArchivedCTA: boolean;
  insuranceApplied?: boolean;
  prescribedDate?: string;
  prescriptionLifecycle: HomePrescriptionLifecycle;
  retrieval?: any;
}

interface HomePatient extends Patient {
  id: string;
}
export interface HomeItem {
  patient: HomePatient;
  items: HomePrescriptionItem[];
}
export interface Home {
  active: HomeItem[];
  archived: HomeItem[];
}

export interface HomeArchivedItem extends HomePrescriptionItem, Patient {
  patientId: string;
}

interface HomeScreenItemAttributes {
  display_name_primary: string;
  display_name_secondary: string;
  dosage: string;
  instructions: string;
  item_type: string;
  patient_first_name: string;
  patient_last_name: string;
  patientmedication_id: string;
  prescription_fulfillment_id: string;
  price: string;
  product_id: string;
  quantity: string;
  refills_remaining: string;
  status_display_external: string;
  status: string;
}

export interface HomeScreenItem {
  id: string;
  attributes: HomeScreenItemAttributes;
}

export interface OptimisticPendingTransfer {
  name: string;
  source?: 'doctor' | 'pharmacy';
}
